import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";

import UserActivityInsystem from "./UserActivityInSystem";
import AlertResolvingActivity from "./AlertResolvingActivity";

const UserActivityLogs = () => {
  const [activeSubTab, setActiveSubTab] = useState(0);

  const subTabs = [
    { label: "Alerts resolved history", content: <AlertResolvingActivity /> },
    { label: "Audit Trails", content: <UserActivityInsystem /> },
    
  ];

  return (
    <Box>
      {/* Sub Tabs */}
      <Box
        sx={{
          // borderBottom: 1,
          // borderColor: "divider",
          mt: 1,
           "@media (max-width: 768px)": {
            marginLeft: "35px"
           }
          // backgroundColor: "#252525",
        }}
      >
        <Tabs
          value={activeSubTab}
          onChange={(e, newValue) => setActiveSubTab(newValue)}
        >
          {subTabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                "&.Mui-selected": {
                 borderBottom: 1, borderColor: "divider" 
                },
                ml: 2,
                
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Sub Tab Content */}
      <Box sx={{ p: 1 }}>
        {subTabs[activeSubTab].content}
      </Box>
    </Box>
  );
};

export default UserActivityLogs;